/** Shown instead of the app when required build-time configuration is missing. */
export function ConfigError() {
  return (
    <div className="min-h-screen flex items-center justify-center p-6 text-center">
      <div className="max-w-md space-y-3">
        <h1 className="text-xl font-semibold">Login is not configured</h1>
        <p className="text-dark-muted text-sm">
          Set <code className="font-mono">VITE_PRIVY_APP_ID</code> (and optionally <code className="font-mono">VITE_PRIVY_CLIENT_ID</code>) in{' '}
          <code className="font-mono">client/.env</code>, then rebuild. See <code className="font-mono">client/.env.example</code>.
        </p>
      </div>
    </div>
  );
}
